import engine from "store/src/store-engine";
import sessionStorage from "store/storages/sessionStorage";
import defaultPlugins from "store/plugins/defaults";

const storages = [sessionStorage];
const plugins = [defaultPlugins];
const namespace = "manage";

const store = engine.createStore(storages, plugins, namespace);

export { store };
